/**
 * Legacy translation object. For new keys and app-wide labels, use i18n JSON files
 * (src/i18n/fr.json, en.json, etc.) and t() from react-i18next.
 */
export const translations = {
  FR: {
    // Common
    common: {
      save: 'Enregistrer',
      cancel: 'Annuler',
      delete: 'Supprimer',
      edit: 'Modifier',
      create: 'Créer',
      search: 'Rechercher',
      filter: 'Filtrer',
      export: 'Exporter',
      import: 'Importer',
      loading: 'Chargement...',
      noData: 'Aucune donnée disponible',
      error: 'Erreur',
      success: 'Succès',
      confirm: 'Confirmer',
      back: 'Retour',
      next: 'Suivant',
      previous: 'Précédent',
      close: 'Fermer',
      view: 'Voir',
      download: 'Télécharger',
      upload: 'Téléverser',
      active: 'Actif',
      inactive: 'Inactif',
      all: 'Tous'
    },
    
    // Advanced Billing
    billing: {
      title: 'Facturation Avancée',
      discountRules: 'Règles de Remise',
      paymentPhases: 'Phases de Paiement',
      countries: 'Pays',
      analytics: 'Analyses',
      createDiscount: 'Créer une Remise',
      discountType: 'Type de Remise',
      discountPercentage: 'Pourcentage',
      minQuantity: 'Quantité Minimale',
      minAmount: 'Montant Minimal',
      validFrom: 'Valide du',
      validUntil: 'Valide jusqu\'au',
      automaticDiscount: 'Remise Automatique',
      volumeDiscount: 'Remise sur Volume',
      earlyPayment: 'Paiement Anticipé',
      loyalty: 'Fidélité',
      seasonal: 'Saisonnier',
      custom: 'Personnalisé',
      phaseNumber: 'Phase N°',
      phaseName: 'Nom de la Phase',
      amount: 'Montant',
      dueDate: 'Date d\'Échéance',
      status: 'Statut',
      pending: 'En Attente',
      paid: 'Payé',
      overdue: 'En Retard',
      cancelled: 'Annulé'
    },
    
    // User Roles
    roles: {
      title: 'Profils Multi-Rôles',
      userRoles: 'Rôles Utilisateurs',
      roleAssignments: 'Affectations de Rôles',
      permissions: 'Permissions',
      geographicAccess: 'Accès Géographique',
      dentistClient: 'Dentiste Client',
      dentistSupplier: 'Dentiste Fournisseur',
      distributor: 'Distributeur',
      administrator: 'Administrateur',
      productionSupplier: 'Fournisseur de Production',
      assignRole: 'Affecter un Rôle',
      removeRole: 'Retirer le Rôle',
      canBeClient: 'Peut être Client',
      canBeSupplier: 'Peut être Fournisseur',
      regionAccess: 'Accès Régional'
    },
    
    // Navigation
    dashboard: 'Tableau de Bord',
    users: 'Utilisateurs',
    usersAndAccess: 'Utilisateurs et accès',
    usersAndAccessSubtitle:
      'Gérer les comptes, les rôles et les permissions',
    multiRoleManagement: 'Gestion Rôles et Permissions',

    adminIdentity: {
      referenceAndPermissions: 'Référence & permissions',
      assignmentsAndAccess: 'Affectations & accès',
      referenceIntro:
        'Rôles = profil métier (dossiers, workflow, sécurité). Permissions = pages visibles dans le menu uniquement. Jalons de phase = Workflow des commandes. « Profil défaut » ajoute les entrées menu recommandées sans retirer les droits déjà accordés.',
      viewRolesCatalog: 'Catalogue des rôles',
      viewPermissionsMatrix: 'Matrice des permissions',
      viewByUser: 'Par utilisateur',
      viewByCountry: 'Par pays / global',
      permissionsSearchPlaceholder: 'Rechercher une permission…',
      assignmentsSearchPlaceholder: 'Rechercher utilisateur, rôle…',
      assignmentActiveOnly: 'Actives seulement',
      assignmentShowAll: 'Toutes',
      assignmentStatusActive: 'Actif',
      assignmentStatusInactive: 'Inactif',
      confirmRemoveAssignmentTitle: 'Retirer cette affectation ?',
      confirmRemoveAssignmentBody:
        'L’utilisateur perdra ce rôle jusqu’à une nouvelle affectation.',
      userIdFallback: 'Utilisateur inconnu',
    },

    adminAssignRole: {
      title: 'Affecter un rôle à un utilisateur',
      selectUser: 'Utilisateur',
      selectRole: 'Rôle',
      countryOptional: 'Pays (optionnel)',
      noCountryRestriction: 'Aucune restriction pays',
      countryDescription: 'Restreindre cette affectation à un pays précis.',
      regionOptional: 'Régions (optionnel)',
      regionPlaceholder: 'ex. Nord, Sud (virgules)',
      regionDescription: 'Sous-parties géographiques, séparées par des virgules.',
      submit: 'Affecter',
      userSearchPlaceholder: 'Filtrer la liste utilisateurs…',
      errors: {
        userRequired: 'Sélectionnez un utilisateur.',
        roleRequired: 'Sélectionnez un rôle.',
      },
    },

    adminRoleCrud: {
      catalogTitle: 'Catalogue des rôles',
      catalogIntro:
        'Onglet « Référence & permissions » → catalogue des rôles. « Nouveau rôle » crée une entrée avec un identifiant technique en snake_case (ex. coordinateur_regional). Ce slug est utilisé dans l’application (routes, politiques) : prévoyez ensuite d’autoriser ce rôle où il est nécessaire. Pour modifier le libellé ou la description d’un rôle existant, utilisez « Modifier ».',
      newRole: 'Nouveau rôle',
      editRole: 'Modifier le rôle',
      save: 'Enregistrer',
      createExplain:
        'Saisissez un identifiant technique unique en snake_case (minuscules, chiffres, underscores ; commence par une lettre). Il est normalisé en minuscules à la validation. Puis renseignez le libellé affiché et la description.',
      roleType: 'Identifiant technique (role_type)',
      roleTypePlaceholder: 'ex. logistics_coordinator_custom',
      roleTypeReadOnly: 'Non modifiable après création',
      roleTypeHint:
        'Format : lettre minuscule puis segments [a-z0-9] séparés par un underscore (max. 100 caractères). Ne doit pas correspondre à un role_type déjà présent dans le catalogue.',
      roleName: 'Libellé affiché',
      description: 'Description',
      canBeClient: 'Peut être client',
      canBeSupplier: 'Peut être fournisseur',
      isActive: 'Rôle actif',
      noTypesLeftTitle: 'Aucun identifiant libre pour « Nouveau rôle »',
      noTypesLeft:
        'Soit tous les identifiants connus par l’application ont déjà une carte dans ce catalogue, soit votre base locale n’a pas encore reçu les dernières migrations.\n\n• Pour modifier un rôle : bouton « Modifier » sur la carte.\n• Pour un identifiant vraiment nouveau : faire ajouter ALTER TYPE … ADD VALUE (migration Supabase), déployer, puis le slug apparaîtra dans cette liste.',
      deleteRole: 'Supprimer le rôle',
      deleteTitle: 'Supprimer ce rôle ?',
      deleteBody:
        'Les affectations liées seront supprimées (effet cascade). Les utilisateurs perdront ce rôle.',
      assignmentCountLabel: '{{count}} affectation(s)',
      cancel: 'Annuler',
      errors: {
        roleTypeRequired: 'Saisissez un identifiant technique.',
        roleTypeInvalidSnake:
          'Format invalide : utilisez le snake_case (ex. mon_role), lettres minuscules, chiffres et underscores, sans espace.',
        roleNameRequired: 'Le libellé est requis.',
        roleTypeTaken: 'Ce role_type existe déjà.',
      },
    },
    
    // International
    international: {
      title: 'Gestion Internationale',
      markets: 'Marchés',
      languages: 'Langues',
      countryCode: 'Code Pays',
      countryName: 'Nom du Pays',
      region: 'Région',
      currency: 'Devise',
      taxRate: 'Taux de TVA',
      paymentMethods: 'Modes de Paiement',
      regulatoryRequirements: 'Exigences Réglementaires',
      addCountry: 'Ajouter un Pays',
      editCountry: 'Modifier le Pays',
      marketConfiguration: 'Configuration du Marché',
      compliance: 'Conformité',
      localPartners: 'Partenaires Locaux'
    }
  },
  
  EN: {
    // Common
    common: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      search: 'Search',
      filter: 'Filter',
      export: 'Export',
      import: 'Import',
      loading: 'Loading...',
      noData: 'No data available',
      error: 'Error',
      success: 'Success',
      confirm: 'Confirm',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      close: 'Close',
      view: 'View',
      download: 'Download',
      upload: 'Upload',
      active: 'Active',
      inactive: 'Inactive',
      all: 'All'
    },
    
    // Advanced Billing
    billing: {
      title: 'Advanced Billing',
      discountRules: 'Discount Rules',
      paymentPhases: 'Payment Phases',
      countries: 'Countries',
      analytics: 'Analytics',
      createDiscount: 'Create Discount',
      discountType: 'Discount Type',
      discountPercentage: 'Percentage',
      minQuantity: 'Minimum Quantity',
      minAmount: 'Minimum Amount',
      validFrom: 'Valid From',
      validUntil: 'Valid Until',
      automaticDiscount: 'Automatic Discount',
      volumeDiscount: 'Volume Discount',
      earlyPayment: 'Early Payment',
      loyalty: 'Loyalty',
      seasonal: 'Seasonal',
      custom: 'Custom',
      phaseNumber: 'Phase No.',
      phaseName: 'Phase Name',
      amount: 'Amount',
      dueDate: 'Due Date',
      status: 'Status',
      pending: 'Pending',
      paid: 'Paid',
      overdue: 'Overdue',
      cancelled: 'Cancelled'
    },
    
    // User Roles
    roles: {
      title: 'Multi-Role Profiles',
      userRoles: 'User Roles',
      roleAssignments: 'Role Assignments',
      permissions: 'Permissions',
      geographicAccess: 'Geographic Access',
      dentistClient: 'Dentist Client',
      dentistSupplier: 'Dentist Supplier',
      distributor: 'Distributor',
      administrator: 'Administrator',
      productionSupplier: 'Production Supplier',
      assignRole: 'Assign Role',
      removeRole: 'Remove Role',
      canBeClient: 'Can Be Client',
      canBeSupplier: 'Can Be Supplier',
      regionAccess: 'Regional Access'
    },
    
    // Navigation
    dashboard: 'Dashboard',
    users: 'Users',
    usersAndAccess: 'Users & access',
    usersAndAccessSubtitle:
      'Manage accounts, roles, and permissions',
    multiRoleManagement: 'Multi-Role Management',

    adminIdentity: {
      referenceAndPermissions: 'Reference & permissions',
      assignmentsAndAccess: 'Assignments & access',
      referenceIntro:
        'Roles = business profile (cases, workflow, data security). Permissions = visible menu pages only. Phase milestones = Order workflow. Default preset adds recommended menu entries without removing existing grants.',
      viewRolesCatalog: 'Role catalogue',
      viewPermissionsMatrix: 'Permissions matrix',
      viewByUser: 'By user',
      viewByCountry: 'By country / global',
      permissionsSearchPlaceholder: 'Search permission…',
      assignmentsSearchPlaceholder: 'Search user, role…',
      assignmentActiveOnly: 'Active only',
      assignmentShowAll: 'All',
      assignmentStatusActive: 'Active',
      assignmentStatusInactive: 'Inactive',
      confirmRemoveAssignmentTitle: 'Remove this assignment?',
      confirmRemoveAssignmentBody:
        'The user will lose this role until reassigned.',
      userIdFallback: 'Unknown user',
    },

    adminAssignRole: {
      title: 'Assign role to user',
      selectUser: 'User',
      selectRole: 'Role',
      countryOptional: 'Country (optional)',
      noCountryRestriction: 'No country restriction',
      countryDescription: 'Restrict this assignment to one country.',
      regionOptional: 'Regions (optional)',
      regionPlaceholder: 'e.g. North, South (comma-separated)',
      regionDescription: 'Geographic sub-areas as comma-separated values.',
      submit: 'Assign',
      userSearchPlaceholder: 'Filter user list…',
      errors: {
        userRequired: 'Select a user.',
        roleRequired: 'Select a role.',
      },
    },

    adminRoleCrud: {
      catalogTitle: 'Role catalogue',
      catalogIntro:
        'Reference & permissions → role catalogue. “New role” creates an entry with a technical snake_case identifier (e.g. regional_coordinator). That slug is used across the app (routes, policies): allow it where needed. Use “Edit” to change the display label or description of an existing role.',
      newRole: 'New role',
      editRole: 'Edit role',
      save: 'Save',
      createExplain:
        'Enter a unique technical id in snake_case (lowercase letters, digits, underscores; must start with a letter). It is lowercased on save. Then set the display label and description.',
      roleType: 'Technical id (role_type)',
      roleTypePlaceholder: 'e.g. logistics_coordinator_custom',
      roleTypeReadOnly: 'Cannot be changed after creation',
      roleTypeHint:
        'Pattern: lowercase letter, then [a-z0-9] segments separated by underscores (max 100 chars). Must not match an existing role_type in this catalogue.',
      roleName: 'Display label',
      description: 'Description',
      canBeClient: 'Can be client',
      canBeSupplier: 'Can be supplier',
      isActive: 'Role active',
      noTypesLeftTitle: 'No spare identifier for “New role”',
      noTypesLeft:
        'Either every app-known identifier already has a catalogue card, or your local DB is missing migrations.\n\n• To change wording: “Edit” on the card.\n• For a brand-new slug: add ALTER TYPE … ADD VALUE (migration), deploy, then it will show up here.',
      deleteRole: 'Delete role',
      deleteTitle: 'Delete this role?',
      deleteBody:
        'Linked assignments will be removed (cascade). Users lose this role.',
      assignmentCountLabel: '{{count}} assignment(s)',
      cancel: 'Cancel',
      errors: {
        roleTypeRequired: 'Enter a technical id.',
        roleTypeInvalidSnake:
          'Invalid format: use snake_case (e.g. my_role), lowercase letters, digits and underscores, no spaces.',
        roleNameRequired: 'Display label is required.',
        roleTypeTaken: 'This role_type already exists.',
      },
    },
    
    // International
    international: {
      title: 'International Management',
      markets: 'Markets',
      languages: 'Languages',
      countryCode: 'Country Code',
      countryName: 'Country Name',
      region: 'Region',
      currency: 'Currency',
      taxRate: 'Tax Rate',
      paymentMethods: 'Payment Methods',
      regulatoryRequirements: 'Regulatory Requirements',
      addCountry: 'Add Country',
      editCountry: 'Edit Country',
      marketConfiguration: 'Market Configuration',
      compliance: 'Compliance',
      localPartners: 'Local Partners'
    }
  },
  
  PL: {
    // Common
    common: {
      save: 'Zapisz',
      cancel: 'Anuluj',
      delete: 'Usuń',
      edit: 'Edytuj',
      create: 'Utwórz',
      search: 'Szukaj',
      filter: 'Filtruj',
      export: 'Eksportuj',
      import: 'Importuj',
      loading: 'Ładowanie...',
      noData: 'Brak danych',
      error: 'Błąd',
      success: 'Sukces',
      confirm: 'Potwierdź',
      back: 'Wstecz',
      next: 'Dalej',
      previous: 'Poprzedni',
      close: 'Zamknij',
      view: 'Zobacz',
      download: 'Pobierz',
      upload: 'Prześlij',
      active: 'Aktywny',
      inactive: 'Nieaktywny',
      all: 'Wszystkie'
    },
    
    // Advanced Billing
    billing: {
      title: 'Zaawansowana Fakturacja',
      discountRules: 'Zasady Rabatów',
      paymentPhases: 'Fazy Płatności',
      countries: 'Kraje',
      analytics: 'Analityka',
      createDiscount: 'Utwórz Rabat',
      discountType: 'Typ Rabatu',
      discountPercentage: 'Procent',
      minQuantity: 'Minimalna Ilość',
      minAmount: 'Minimalna Kwota',
      validFrom: 'Ważny Od',
      validUntil: 'Ważny Do',
      automaticDiscount: 'Automatyczny Rabat',
      volumeDiscount: 'Rabat Ilościowy',
      earlyPayment: 'Wcześniejsza Płatność',
      loyalty: 'Lojalność',
      seasonal: 'Sezonowy',
      custom: 'Niestandardowy',
      phaseNumber: 'Faza Nr',
      phaseName: 'Nazwa Fazy',
      amount: 'Kwota',
      dueDate: 'Termin Płatności',
      status: 'Status',
      pending: 'Oczekujący',
      paid: 'Opłacony',
      overdue: 'Przeterminowany',
      cancelled: 'Anulowany'
    },
    
    // User Roles
    roles: {
      title: 'Profile Wielorolowe',
      userRoles: 'Role Użytkowników',
      roleAssignments: 'Przypisania Ról',
      permissions: 'Uprawnienia',
      geographicAccess: 'Dostęp Geograficzny',
      dentistClient: 'Dentysta Klient',
      dentistSupplier: 'Dentysta Dostawca',
      distributor: 'Dystrybutor',
      administrator: 'Administrator',
      productionSupplier: 'Dostawca Produkcji',
      assignRole: 'Przypisz Rolę',
      removeRole: 'Usuń Rolę',
      canBeClient: 'Może Być Klientem',
      canBeSupplier: 'Może Być Dostawcą',
      regionAccess: 'Dostęp Regionalny'
    },
    
    // Navigation
    dashboard: 'Panel',
    users: 'Użytkownicy',
    usersAndAccess: 'Użytkownicy i dostęp',
    usersAndAccessSubtitle:
      'Zarządzaj kontami, rolami i uprawnieniami',
    multiRoleManagement: 'Zarządzanie Wielorolowe',

    adminIdentity: {
      referenceAndPermissions: 'Referencja i uprawnienia',
      assignmentsAndAccess: 'Przypisania i dostęp',
      referenceIntro:
        'Role = profil biznesowy. Uprawnienia = tylko widoczne strony menu. Kamienie milowe = Workflow zamówień. Profil domyślny dodaje zalecane wpisy menu.',
      viewRolesCatalog: 'Katalog ról',
      viewPermissionsMatrix: 'Macierz uprawnień',
      viewByUser: 'Według użytkownika',
      viewByCountry: 'Według kraju / globalnie',
      permissionsSearchPlaceholder: 'Szukaj uprawnienia…',
      assignmentsSearchPlaceholder: 'Szukaj użytkownika, roli…',
      assignmentActiveOnly: 'Tylko aktywne',
      assignmentShowAll: 'Wszystkie',
      assignmentStatusActive: 'Aktywny',
      assignmentStatusInactive: 'Nieaktywny',
      confirmRemoveAssignmentTitle: 'Usunąć to przypisanie?',
      confirmRemoveAssignmentBody:
        'Użytkownik straci tę rolę do ponownego przypisania.',
      userIdFallback: 'Nieznany użytkownik',
    },

    adminAssignRole: {
      title: 'Przypisz rolę użytkownikowi',
      selectUser: 'Użytkownik',
      selectRole: 'Rola',
      countryOptional: 'Kraj (opcjonalnie)',
      noCountryRestriction: 'Bez ograniczenia kraju',
      countryDescription: 'Ogranicz przypisanie do jednego kraju.',
      regionOptional: 'Regiony (opcjonalnie)',
      regionPlaceholder: 'np. Północ, Południe (przecinki)',
      regionDescription: 'Podobszary, oddzielone przecinkami.',
      submit: 'Przypisz',
      userSearchPlaceholder: 'Filtruj listę…',
      errors: {
        userRequired: 'Wybierz użytkownika.',
        roleRequired: 'Wybierz rolę.',
      },
    },

    adminRoleCrud: {
      catalogTitle: 'Katalog ról',
      catalogIntro:
        'Reference & permissions → katalog ról. „Nowa rola” tworzy wpis z technicznym identyfikatorem snake_case (np. regionalny_koordynator). Slug jest używany w aplikacji (trasy, polityki): należy go potem uwzględnić tam, gdzie potrzeba. Nazwę lub opis istniejącej roli zmienisz przyciskiem „Edytuj”.',
      newRole: 'Nowa rola',
      editRole: 'Edytuj rolę',
      save: 'Zapisz',
      createExplain:
        'Wpisz unikalny identyfikator techniczny w snake_case (małe litery, cyfry, podkreślenia; zaczyna się od litery). Przy zapisie jest zamieniany na małe litery. Potem ustaw etykietę i opis.',
      roleType: 'Identyfikator techniczny (role_type)',
      roleTypePlaceholder: 'np. logistics_coordinator_custom',
      roleTypeReadOnly: 'Bez zmiany po utworzeniu',
      roleTypeHint:
        'Wzorzec: mała litera, potem segmenty [a-z0-9] oddzielone podkreśleniami (maks. 100 znaków). Nie może powtarzać istniejącego role_type w katalogu.',
      roleName: 'Etykieta wyświetlana',
      description: 'Opis',
      canBeClient: 'Może być klientem',
      canBeSupplier: 'Może być dostawcą',
      isActive: 'Rola aktywna',
      noTypesLeftTitle: 'Brak wolnego identyfikatora dla „Nowa rola”',
      noTypesLeft:
        'Albo wszystkie znane identyfikatory mają już karty w katalogu, albo migracje nie zostały zastosowane.\n\n• Zmiana opisu lub nazwy — „Edytuj”.\n• Nowy slug — migracja ALTER TYPE … ADD VALUE, wdrożenie, potem pojawi się na liście.',
      deleteRole: 'Usuń rolę',
      deleteTitle: 'Usunąć tę rolę?',
      deleteBody:
        'Powiązane przypisania zostaną usunięte (kaskada).',
      assignmentCountLabel: '{{count}} przypisań',
      cancel: 'Anuluj',
      errors: {
        roleTypeRequired: 'Wpisz identyfikator techniczny.',
        roleTypeInvalidSnake:
          'Niepoprawny format: użyj snake_case (np. moja_rola), małe litery, cyfry i podkreślenia, bez spacji.',
        roleNameRequired: 'Etykieta jest wymagana.',
        roleTypeTaken: 'Ten role_type już istnieje.',
      },
    },
    
    // International
    international: {
      title: 'Zarządzanie Międzynarodowe',
      markets: 'Rynki',
      languages: 'Języki',
      countryCode: 'Kod Kraju',
      countryName: 'Nazwa Kraju',
      region: 'Region',
      currency: 'Waluta',
      taxRate: 'Stawka Podatku',
      paymentMethods: 'Metody Płatności',
      regulatoryRequirements: 'Wymagania Regulacyjne',
      addCountry: 'Dodaj Kraj',
      editCountry: 'Edytuj Kraj',
      marketConfiguration: 'Konfiguracja Rynku',
      compliance: 'Zgodność',
      localPartners: 'Lokalni Partnerzy'
    }
  }
};

export const getTranslation = (language = 'FR') => {
  return translations?.[language] || translations?.FR;
};

export default { translations, getTranslation };